import React, { useState, useEffect } from 'react';
import './UpcomingTasks.css';
import axios from 'axios';
import moment from "moment";
import { APIURL } from '../../../../config';
import { convertTime } from 'src/utils/time';

const UpcomingTasks = (props) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedTaskId, setExpandedTaskId] = useState(null);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        setLoading(true);
        // TODO: Replace with actual API call
        // const response = await fetch(`/api/tasks/upcoming/${userId}?limit=10`);
        // const data = await response.json();
        
        // Fetch regular task data only
        const emp_id = props.user.emp_id;
        let appointments = await axios.get(`${APIURL}/task`, { params: { emp_id } });
        
        // Filter and process regular tasks
        const now = new Date();
        const ninetyDaysAgo = new Date(now.getTime() - (90 * 24 * 60 * 60 * 1000));
        const ninetyDaysFromNow = new Date(now.getTime() + (90 * 24 * 60 * 60 * 1000));
        
        console.log('Raw task data:', appointments.data);

        let tasks = (appointments.data || [])
          .filter((task) => {
            const taskStartTime = new Date(task.tas_start_time);
            return task.tas_is_active === 0 && 
              taskStartTime >= ninetyDaysAgo && taskStartTime <= ninetyDaysFromNow;
          });
        
        // Sort by start time (chronological order - earliest first) and limit to 10
        const sortedTasks = tasks
          .sort((a, b) => new Date(a.tas_start_time) - new Date(b.tas_start_time))
          .slice(0, 10);
        
        setTasks(sortedTasks);
        setError(null);
        console.log('Fetched tasks:', sortedTasks);
      } catch (err) {
        setError('Failed to load upcoming tasks');
        console.error('Error fetching tasks:', err);
      } finally {
        setLoading(false);
      }
    };

    if (props.user) {
      fetchTasks();
    }
  }, [props.user]);

  const formatDate = (dateString) => {
    console.log('Formatting date:', dateString);
    const date = new Date(dateString);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    // Check if it's today or tomorrow
    if (date.toDateString() === today.toDateString()) {
      return `Today ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    } else if (date.toDateString() === tomorrow.toDateString()) {
      return `Tomorrow ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    } else {
      return date.toLocaleDateString([], { 
        month: 'short', 
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  };

  const handleTaskTitleClick = (taskId) => {
    setExpandedTaskId(expandedTaskId === taskId ? null : taskId);
  };

  const getCustomerName = (task) => {
    return task.cusInfo && task.cusInfo.length > 0 ? task.cusInfo[0].cus_name : 'N/A';
  };

  const formatDateOnly = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    // Check if it's today or tomorrow
    if (date.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (date.toDateString() === tomorrow.toDateString()) {
      return 'Tomorrow';
    } else {
      return date.toLocaleDateString([], { 
        month: 'short', 
        day: 'numeric'
      });
    }
  };



  const getTaskTypeColor = (taskType) => {
    const colors = {
      'TaskType1': '#4CAF50',
      'TaskType2': '#2196F3',
      'TaskType3': '#FF9800',
      'TaskType4': '#9C27B0',
      'TaskType5': '#F44336'
    };
    return colors[taskType] || '#3fa7d6';
  };

  if (loading) {
    return (
      <div className="upcoming-tasks">
        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '20px', whiteSpace: 'nowrap' }}>UPCOMING APPOINTMENTS</div>
            <div className='patient_top_appointments_number'>Loading your appointments...</div>
          </div>
        </div>
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading upcoming tasks...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="upcoming-tasks">
        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '20px', whiteSpace: 'nowrap' }}>UPCOMING APPOINTMENTS</div>
            <div className='patient_top_appointments_number'>Failed to load appointments.</div>
          </div>
        </div>
        <div className="error-state">
          <p>{error}</p>
          <button 
            className="retry-btn"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (tasks.length === 0) {
    return (
      <div className="upcoming-tasks">
        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '20px', whiteSpace: 'nowrap' }}>UPCOMING APPOINTMENTS</div>
            <div className='patient_top_appointments_number'>No upcoming appointments found.</div>
          </div>
        </div>
        <div className="empty-state">
          <p>No upcoming tasks found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="upcoming-tasks">
      <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: '20px', whiteSpace: 'nowrap' }}>UPCOMING TASKS</div>
          <div className='patient_top_appointments_number'>Your next {tasks.length} appointments.</div>
        </div>
      </div>
      
      <div className="tasks-list">
        {tasks.map((task) => (
          <div key={task.tas_id} className="task-item">
            <div 
              className={window.innerWidth <= 768 ? "task-row-mobile clickable-row" : "task-row clickable-row"}
              onClick={() => handleTaskTitleClick(task.tas_id)}
            >
              <div className="date-title-section">
                <div className="end-date">
                  {formatDateOnly(task.tas_end_time)}
                </div>
                <div className="task-title-with-type">
                  <span className="task-title-text">
                    {task.tas_title}
                  </span>
                  <span className={expandedTaskId === task.tas_id ? "expand-icon-expanded" : "expand-icon"}>
                    ▼
                  </span>
                </div>
              </div>
              
              <div className="customer-section">
                <span 
                  className="task-type-badge"
                  style={{ backgroundColor: getTaskTypeColor(task.tas_type) }}
                >
                  {task.tas_type}
                </span>
                <div className={window.innerWidth <= 768 ? "customer-name-mobile" : "customer-name"}>
                  {getCustomerName(task)}
                </div>
              </div>
            </div>
            
            <div className={expandedTaskId === task.tas_id ? "task-details-expanded" : "task-details"}>
              <div className="task-details-content">
                <div className="detail-row">
                  <label className="detail-label">Start Time:</label>
                  <span className="detail-value">{formatDate(convertTime(task.tas_start_time, task.task_emp_timezone, moment.tz.guess()) ?? task.tas_start_time)}</span>
                </div>
                <div className="detail-row">
                  <label className="detail-label">End Time:</label>
                  <span className="detail-value">{formatDate(convertTime(task.tas_end_time, task.task_emp_timezone, moment.tz.guess()) ?? task.tas_end_time)}</span>
                </div>
                <div className="detail-row">
                  <label className="detail-label">Description:</label>
                  <p className="detail-value">{task.tas_description || task.tas_notes || 'No description available'}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingTasks;
